import * as React from "react";
import { Spinner } from "reactstrap";
import { rankingLabels } from "../utils/formatRankingData";

const RankingSummary = (props) => {
  const { user, data, filter, month, description, isLoading } = props;

  return (
    <div
      className="d-flex"
      style={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "3.5rem",
        maxWidth: "min-content",
        margin: "2rem",
        minHeight: "450px"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2 style={{ color: "#1D1F3F" }}>
          Muchas felicidades {user?.data.nombre.split(" ")[0]}
        </h2>
        <h4 style={{ color: "#1D1F3F" }}>{description}</h4>
      </div>

      <div
        style={{
          borderRadius: "15px",
          display: "flex",
          flexDirection: "column",
          minWidth: "495px",
          minHeight: "320px",
          justifyContent: "center"
        }}
      >
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner color="primary" />
          </div>
        ) : (
          <React.Fragment>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  flexDirection: "column",
                  backgroundColor: "#1B7ACB",
                  borderTopLeftRadius: "15px",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "2rem",
                  height: "250px",
                  width: "165px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    minHeight: "4rem",
                  }}
                >
                  <h6
                    style={{
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    Mes Anterior:
                  </h6>
                  <span style={{ color: "white", lineHeight: 0.5 }}>
                    {data.previousMonth?.month}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2.5rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#A0DC21",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {Math.round(data.previousMonth?.value) || "-"}
                    </span>
                    <span style={{ color: "white", lineHeight: 0.5 }}>
                      {rankingLabels[filter]}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#A0DC21",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {data.previousMonth?.position || "-"}
                    </span>
                    <span style={{ color: "white", lineHeight: 0.5 }}>
                      Posición
                    </span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  flexDirection: "column",
                  backgroundColor: "#1D1F3F",
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "2rem",
                  height: "320px",
                  width: "165px",
                  position: "relative",
                }}
              >
                <img
                  src={require("../../../assets/images/coin.png")}
                  alt="ibi-coin"
                  style={{
                    width: "90px",
                    height: "90px",
                    position: "absolute",
                    top: -40,
                  }}
                />
                <h2
                  style={{
                    textAlign: "center",
                    width: "88px",
                    color: "white",
                    minHeight: "4rem",
                  }}
                >
                  {month}
                </h2>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2.5rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FB9639",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {Math.round(data.currentMonth?.value) || "-"}
                    </span>
                    <span style={{ color: "white", lineHeight: 0.5 }}>
                      {rankingLabels[filter]}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#FB9639",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {data.currentMonth?.position || "-"}
                    </span>
                    <span style={{ color: "white", lineHeight: 0.5 }}>
                      Posición
                    </span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  flexDirection: "column",
                  backgroundColor: "#1B7ACB",
                  borderTopRightRadius: "15px",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "2rem",
                  height: "250px",
                  width: "165px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    minHeight: "4rem",
                  }}
                >
                  <h4
                    style={{
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    Tu récord
                  </h4>
                  <span style={{ color: "white", lineHeight: 0.5 }}>
                    {data.record?.month}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2.5rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#A0DC21",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {Math.round(data.record?.value) || "-"}
                    </span>
                    <span style={{ color: "white", lineHeight: 0.5 }}>
                      {rankingLabels[filter]}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#A0DC21",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {data.record?.position || "-"}
                    </span>
                    <span style={{ color: "white", lineHeight: 0.5 }}>
                      Posición
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                borderBottomLeftRadius: "15px",
                borderBottomRightRadius: "15px",
                minHeight: "2.5rem",
                backgroundColor: "white",
                WebkitBoxShadow: "0px 5px 5px 4px rgba(0,0,0,0.25)",
                MozBoxShadow: "0px 5px 5px 4px rgba(0,0,0,0.25)",
                boxShadow: "0px 5px 5px 4px rgba(0,0,0,0.25)",
                padding: "1.25rem 1rem",
              }}
            >
              <span style={{ color: "black" }}>
                Tu <b>record</b> considera el mes en que recorriste la mayor
                cantidad de pasos registrados en los <b>últimos 12 meses.</b>
              </span>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default RankingSummary;
